import React from 'react';
import classNames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';

function Leaf(props: any) {
  const classes = useStyles();

  const { attributes, children: _children, leaf } = props;
  const classList = [];
  let children = _children;

  if (leaf.bold) {
    classList.push(classes.bold);
  }

  if (leaf.italic) {
    classList.push(classes.italic);
  }

  if (leaf.strike_through) {
    classList.push(classes.strike_through);
  }

  if (leaf.underline) {
    children = <u>{_children}</u>;
  }

  return (
    <span {...attributes} className={classNames(...classList)}>
      {children}
    </span>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  bold: {
    fontWeight: theme.typography.fontWeightBold,
  },
  italic: {
    fontStyle: 'italic',
  },
  strike_through: {
    textDecoration: 'line-through',
  },
}));

export default Leaf;
